export const cartConstant = {
  SET_CART_ITEMS_REQUEST: "SET_CART_ITEMS_REQUEST",
  SET_CART_ITEMS_SUCCESS: "SET_CART_ITEMS_SUCCESS",
  SET_CART_ITEMS_FAILURE: "SET_CART_ITEMS_FAILURE",

  SET_CLEAR_CART_REQUEST: "SET_CLEAR_CART_REQUEST",
  SET_CLEAR_CART_SUCCESS: "SET_CLEAR_CART_SUCCESS",
  SET_CLEAR_CART_FAILURE: "SET_CLEAR_CART_FAILURE",
};
